<template>
  <div class="row">
    <div :class="['col_12', {'loading_overlay': loading}]">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">{{ $t('sidebar.parking.parking_information') }}</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_12">
              <div :class="['form-group', {'has_error': errorFor('name')}]">
                <label>{{ $t('common.name') }}</label>
                <input type="text" v-model="form.name" class="form_global">
                <v-errors :errors="errorFor('name')" />
              </div>
            </div>
          </div>

          <div class="d_flex_end form_action_btn">
            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
            <button class="btn  btn_blue ml_10" :disabled="loading" @click="submit">{{ $t('common.submit') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: this.$t('sidebar.parking.add_parking'),
      cancelRouteName: 'settings_parkings',
      form: {
        name: '',
      }
    }
  },
  created() {
    if (this.$route.name === 'settings_parking_edit') {
      this.axios.get('/parkings/'+this.$route.params.id)
          .then((response) => {
            this.form = response.data.data;
            delete this.form.id;
          })
      this.title = this.$t('sidebar.parking.edit_parking');
    }
  },
  methods: {
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'settings_parking_edit') {
        this.axios.patch('/parkings/'+this.$route.params.id, this.form)
            .then(() => {
              this.$router.push({name: 'settings_parkings'});
              this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      } else {
        this.axios.post('/parkings', this.form)
            .then(() => {
              this.$router.push({name: 'settings_parkings'});
              this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      }
    }
  }
}
</script>
